import { Component } from "@theme/component";
import { animate } from "https://cdn.jsdelivr.net/npm/motion@latest/+esm";
/**
 * Flippable doctor card wrapper.
 *
 * Uses the Component framework so templates can bind via `on:click="/toggle"`.
 *
 * @extends {Component}
 */
export class DoctorDetailsCardComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#syncA11yState();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#syncA11yState();
  }

  /**
   * Toggle between front/back faces.
   * @param {MouseEvent | KeyboardEvent} [event]
   * @returns {void}
   */
  toggle(event) {
    event?.preventDefault();

    if (this.animation) {
      this.animation.stop();
    }
    const xOffset = this.clientWidth * 0.55;

    const isFlipped = this.hasAttribute("flipped");
    this.style.zIndex = "var(--layer-raised)";

    const cardFront = this.querySelector(".doctor-details-card__face--front");
    const cardBack = this.querySelector(".doctor-details-card__face--back");
    const currentFront = isFlipped ? cardBack : cardFront;
    const currentBack = isFlipped ? cardFront : cardBack;

    const fontSize = parseFloat(getComputedStyle(this).fontSize);
    const offset = 0.375 * fontSize;
    const animation = animate([
      [
        currentFront,
        {
          x: [-1 * offset, xOffset, offset],
          rotate: [0, 3, 0],
          y: [offset, -1 * offset],
          z: ["5px", "0px", "-5px"],
        },
        { duration: 0.5, at: 0, easing: "ease-out" },
      ],
      [
        currentBack,
        {
          x: [offset, -xOffset, -1 * offset],
          rotate: [0, -3, 0],
          y: [-1 * offset, offset],
          z: ["-5px", "0px", "5px"],
        },
        { duration: 0.5, at: 0, easing: "ease-out" },
      ],
    ]).then((res) => {
      if (animation === this.animation) {
        this.animation = null;
      }
      this.style.zIndex = "";
    });
    this.animation = animation;
    this.toggleAttribute("flipped", !isFlipped);

    this.#syncA11yState();
  }

  #syncA11yState() {
    const isFlipped = this.hasAttribute("flipped");

    for (const el of this.querySelectorAll(
      "[data-doctor-details-card-toggle]"
    )) {
      if (!(el instanceof HTMLElement)) continue;
      el.setAttribute("aria-pressed", isFlipped ? "true" : "false");
    }

    const frontFace = this.querySelector(
      '[data-doctor-details-card-face="front"]'
    );
    const backFace = this.querySelector(
      '[data-doctor-details-card-face="back"]'
    );

    if (frontFace instanceof HTMLElement) {
      frontFace.toggleAttribute("inert", isFlipped);
      frontFace.setAttribute("aria-hidden", isFlipped ? "true" : "false");
    }

    if (backFace instanceof HTMLElement) {
      backFace.toggleAttribute("inert", !isFlipped);
      backFace.setAttribute("aria-hidden", isFlipped ? "false" : "true");
    }
  }
}

customElements.define(
  "doctor-details-card-component",
  DoctorDetailsCardComponent
);
